import React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import Label from '@components/Label';
import { SubGroupItem } from '../SubGroupItem';

import * as styles from './style.module.scss';
import * as substyles from '../SubGroupItem/style.module.scss';

const {
  subMenuItem__subgroup,
  subMenuItem__subgroupColumns2,
  subMenuItem__subgroupColumns3,
  subMenuItem__subgroupColumns4,
  subMenuItem__label,
  subMenuItem__dflex,
} = styles;

const { sublink, sublabel, subcaption } = substyles;

export const SubMenuItem = ({
  label,
  submenus: nestedSubmenus,
  subgroups,
  columns,
}) => {
  const columnsAmount = {
    2: `${subMenuItem__subgroupColumns2} ${subMenuItem__dflex}`,
    3: subMenuItem__subgroupColumns3,
    4: subMenuItem__subgroupColumns4,
  };

  return (
    <div
      className={`${subMenuItem__subgroup} ${
        columns ? ` ${columnsAmount[columns]}` : ''
      }`}
    >
      {label && <Label classes={subMenuItem__label}>{label}</Label>}

      {nestedSubmenus?.map((nestedSubmenu, nestedIndex) => (
        <div
          className={subMenuItem__subgroup}
          key={`nested-submenu-${nestedIndex}`}
        >
          {nestedSubmenu.label && (
            <Label classes={subMenuItem__label}>{nestedSubmenu.label}</Label>
          )}
          {nestedSubmenu.subgroups?.map(
            ({ label, href, caption, mobOrder }, nestedSubgroupIndex) => (
              <Link
                to={href}
                className={`${sublink} order-${mobOrder}`}
                key={`nested-subgroup-item-${nestedIndex}-${nestedSubgroupIndex}`}
              >
                <p className={sublabel}>
                  {label}
                </p>
                <p className={`${subcaption}`} dangerouslySetInnerHTML={{ __html: caption }} />
              </Link>
            )
          )}
        </div>
      ))}

      {subgroups &&
        subgroups?.map((subgroup, subIndex) => (
          <SubGroupItem key={`submenu-item-${subIndex}`} {...subgroup} />
        ))}
    </div>
  );
};
